/* Orbita Shop - storefront interactions. Dependency-free.
   Cart drawer via Shopify Section Rendering API, AJAX add/change, mobile menu,
   predictive search, sticky add-to-cart, quantity steppers, toast. */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function url(p) { return ROOT.replace(/\/$/, '') + p; }
  var FREE_SHIP_THRESHOLD = (window.Orbita && window.Orbita.freeShip) || 2900; // cents

  /* ---------- helpers ---------- */
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function money(cents) {
    var fmt = (window.Orbita && window.Orbita.moneyFormat) || '{{amount}} EUR';
    var val = (cents / 100).toFixed(2).replace('.', ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, val).replace('EUR', '€');
  }

  /* ---------- toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add('show');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('show'); }, 2600);
  }

  /* ---------- cart drawer ---------- */
  function openCart() { document.body.classList.add('cart-open'); }
  function closeCart() { document.body.classList.remove('cart-open'); }

  function applyCartHtml(html) {
    if (!html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#cart-drawer-inner');
    var current = $('#cart-drawer-inner');
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      var cnt = fresh.getAttribute('data-cart-count');
      updateBubble(cnt != null ? parseInt(cnt, 10) : null);
    }
  }

  function updateBubble(count) {
    if (count == null) return;
    $all('.cart-count').forEach(function (b) {
      b.textContent = count;
      b.hidden = count < 1;
    });
  }

  function refreshDrawer() {
    fetch(url('/?sections=cart-drawer'), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (d['cart-drawer']) applyCartHtml(d['cart-drawer']); })
      .catch(function () {});
  }

  function postCart(path, body) {
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    return fetch(url(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); });
  }

  function addToCart(id, qty, btn) {
    if (btn) btn.classList.add('is-loading');
    return postCart('/cart/add.js', { items: [{ id: id, quantity: qty || 1 }] })
      .then(function (res) {
        if (btn) btn.classList.remove('is-loading');
        if (!res.ok) { toast(res.data && res.data.description ? res.data.description : 'Nicht verfügbar'); return; }
        if (res.data.sections && res.data.sections['cart-drawer']) applyCartHtml(res.data.sections['cart-drawer']);
        else refreshDrawer();
        openCart();
        toast('Zum Warenkorb hinzugefügt');
      })
      .catch(function () { if (btn) btn.classList.remove('is-loading'); toast('Etwas ist schiefgelaufen'); });
  }

  function changeLine(line, qty) {
    postCart('/cart/change.js', { line: line, quantity: qty })
      .then(function (res) {
        if (res.data.sections && res.data.sections['cart-drawer']) applyCartHtml(res.data.sections['cart-drawer']);
        else refreshDrawer();
        if (typeof res.data.item_count === 'number') updateBubble(res.data.item_count);
      });
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var open = t.closest('[data-cart-open]');
    if (open) { e.preventDefault(); openCart(); refreshDrawer(); return; }
    if (t.closest('[data-cart-close]') || t.classList.contains('cart-scrim')) { closeCart(); return; }

    var addBtn = t.closest('[data-add]');
    if (addBtn) { e.preventDefault(); addToCart(parseInt(addBtn.getAttribute('data-add'), 10), parseInt(addBtn.getAttribute('data-qty') || '1', 10), addBtn); return; }

    var rm = t.closest('[data-remove]');
    if (rm) { e.preventDefault(); changeLine(parseInt(rm.getAttribute('data-remove'), 10), 0); return; }

    var inc = t.closest('[data-line-inc]');
    if (inc) { e.preventDefault(); changeLine(parseInt(inc.getAttribute('data-line-inc'), 10), parseInt(inc.getAttribute('data-qty'), 10) + 1); return; }
    var dec = t.closest('[data-line-dec]');
    if (dec) { e.preventDefault(); var q = parseInt(dec.getAttribute('data-qty'), 10) - 1; changeLine(parseInt(dec.getAttribute('data-line-dec'), 10), q < 0 ? 0 : q); return; }

    if (t.closest('[data-menu-open]')) { e.preventDefault(); document.body.classList.add('menu-open'); return; }
    if (t.closest('[data-menu-close]') || t.classList.contains('menu-scrim')) { document.body.classList.remove('menu-open'); return; }

    var mf = t.closest('[data-mfilter]');
    if (mf) { e.preventDefault(); var fp = $('.filters'); if (fp) { var open = fp.classList.toggle('open'); document.body.classList.toggle('filter-open', open); } return; }
    if (t.closest('[data-filter-close]')) { e.preventDefault(); var fc = $('.filters'); if (fc) fc.classList.remove('open'); document.body.classList.remove('filter-open'); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCart();
      document.body.classList.remove('menu-open');
      var fp = $('.filters'); if (fp) fp.classList.remove('open');
      document.body.classList.remove('filter-open');
    }
  });

  /* ---------- quantity steppers (qty inputs not tied to a cart line) ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]');
    if (!b) return;
    e.preventDefault();
    var wrap = b.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value || '1', 10) + parseInt(b.getAttribute('data-qty-step'), 10);
    input.value = v < 1 ? 1 : v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- product form (PDP) ---------- */
  $all('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var idField = form.querySelector('[name="id"]');
      var qtyField = form.querySelector('[name="quantity"]');
      var btn = form.querySelector('[type="submit"]');
      addToCart(parseInt(idField.value, 10), qtyField ? parseInt(qtyField.value, 10) : 1, btn);
    });
  });

  /* ATC button that reads the selected variant from its product form (keeps the
     native dynamic-checkout button working, since we do not intercept submit). */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add-form]');
    if (!b) return;
    e.preventDefault();
    var form = b.closest('form');
    if (!form) return;
    var idField = form.querySelector('[name="id"]');
    var qtyField = form.querySelector('[name="quantity"]');
    if (!idField || !idField.value) { toast('Bitte ein Format wählen'); return; }
    addToCart(parseInt(idField.value, 10), qtyField ? parseInt(qtyField.value, 10) : 1, b);
  });

  /* Bundle add (Frequently Bought Together) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bundle]');
    if (!b) return;
    e.preventDefault();
    var ids = b.getAttribute('data-bundle').split(',').filter(Boolean);
    b.classList.add('is-loading');
    postCart('/cart/add.js', { items: ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
      .then(function (res) {
        b.classList.remove('is-loading');
        if (res.data.sections && res.data.sections['cart-drawer']) applyCartHtml(res.data.sections['cart-drawer']);
        else refreshDrawer();
        openCart();
        toast('Bundle hinzugefügt');
      }).catch(function () { b.classList.remove('is-loading'); });
  });

  /* Gallery thumbnails */
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-thumb]');
    if (!th) return;
    var src = th.getAttribute('data-thumb');
    var main = $('[data-gmain]');
    if (main && src) main.src = src;
    $all('.pdp-thumb').forEach(function (x) { x.classList.remove('active'); });
    th.classList.add('active');
  });

  /* ---------- variant selection (format buttons) ---------- */
  $all('[data-variants]').forEach(function (group) {
    var form = group.closest('form') || document;
    group.addEventListener('click', function (e) {
      var b = e.target.closest('.vbtn');
      if (!b || b.classList.contains('soldout')) return;
      $all('.vbtn', group).forEach(function (x) { x.classList.remove('active'); });
      b.classList.add('active');
      var vid = b.getAttribute('data-variant-id');
      var price = b.getAttribute('data-variant-price');
      var avail = b.getAttribute('data-variant-available') === 'true';
      var idField = form.querySelector ? form.querySelector('[name="id"]') : null;
      if (idField) idField.value = vid;
      var priceEl = $('[data-current-price]');
      if (priceEl && price) priceEl.textContent = money(parseInt(price, 10));
      var stickyPrice = $('[data-sticky-price]');
      if (stickyPrice && price) stickyPrice.textContent = money(parseInt(price, 10));
      var submit = form.querySelector ? form.querySelector('[type="submit"]') : null;
      if (submit) { submit.disabled = !avail; submit.textContent = avail ? (submit.getAttribute('data-label') || submit.textContent) : 'Ausverkauft'; }
    });
  });

  /* ---------- sticky mobile ATC visibility ---------- */
  var sticky = $('.smobile');
  var atcAnchor = $('.atc');
  if (sticky && atcAnchor && 'IntersectionObserver' in window) {
    sticky.style.transform = 'translateY(100%)';
    sticky.style.transition = 'transform .25s';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { sticky.style.transform = en.isIntersecting ? 'translateY(100%)' : 'translateY(0)'; });
    }, { rootMargin: '0px 0px -200px 0px' });
    io.observe(atcAnchor);
  }

  /* ---------- predictive search ---------- */
  $all('[data-predictive]').forEach(function (input) {
    var box = input.closest('.hsearch') || input.parentElement;
    var panel = document.createElement('div');
    panel.className = 'psearch'; panel.hidden = true;
    box.style.position = 'relative';
    box.appendChild(panel);
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { panel.hidden = true; return; }
      timer = setTimeout(function () {
        fetch(url('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6'), { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!items.length) { panel.hidden = true; return; }
            panel.innerHTML = items.map(function (p) {
              var img = (p.featured_image && p.featured_image.url) || p.image || '';
              if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
              var t = (p.title || '').split(': ')[0].split(' - ')[0].split(' – ')[0];
              var price = (p.price || '').replace('.', ',');
              var author = p.vendor ? '<span class="pa">von ' + p.vendor + '</span>' : '';
              return '<a href="' + p.url + '">' + (img ? '<img src="' + img + '" alt="">' : '') +
                '<span><span class="pt">' + t + '</span><span class="pmeta">' + author +
                (price ? '<span class="pp2">' + price + '&nbsp;&euro;</span>' : '') + '</span></span></a>';
            }).join('');
            panel.hidden = false;
          }).catch(function () { panel.hidden = true; });
      }, 220);
    });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) panel.hidden = true; });
  });

  /* ---------- collection filters auto-submit ---------- */
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-auto-submit]');
    if (!el) return;
    var form = el.closest('form');
    if (form) form.submit();
  });

  /* ---------- smooth accordion (Details / Versand / Retoure) ---------- */
  document.addEventListener('click', function (e) {
    var head = e.target.closest('[data-acc]');
    if (!head) return;
    var panel = head.nextElementSibling;
    var open = head.getAttribute('aria-expanded') === 'true';
    head.setAttribute('aria-expanded', open ? 'false' : 'true');
    if (panel) panel.classList.toggle('open', !open);
  });

  /* ---------- Mehr laden (statt Seitenzahlen) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-loadmore]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-next');
    if (!url || btn.dataset.loading) return;
    btn.dataset.loading = '1';
    var orig = btn.textContent.trim();
    btn.textContent = 'Lädt …';
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('[data-product-grid]');
      var grid = document.querySelector('[data-product-grid]');
      if (newGrid && grid) {
        while (newGrid.firstElementChild) { grid.appendChild(newGrid.firstElementChild); }
      }
      var nextBtn = doc.querySelector('[data-loadmore]');
      if (nextBtn && nextBtn.getAttribute('data-next')) {
        btn.setAttribute('data-next', nextBtn.getAttribute('data-next'));
        btn.textContent = orig;
        btn.dataset.loading = '';
      } else {
        var wrap = btn.closest('.loadmore-wrap');
        if (wrap) { wrap.remove(); } else { btn.remove(); }
      }
    }).catch(function () { btn.textContent = orig; btn.dataset.loading = ''; });
  });

  /* expose for inline use */
  window.OrbitaCart = { add: addToCart, open: openCart, refresh: refreshDrawer };
})();
